import React, { useState, useContext, useEffect, SyntheticEvent } from "react";

import {
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Input,
  InputGroup,
  FormGroup,
  Label,
  Spinner,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import api from "../../../../../../../services/api";
import Select from "react-select";
import EmpresaContext from "../../../../../../../contexts/Empresa";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Select2 from "react-select2-wrapper";
import { GoogleIcon } from "../../../../../../security/Users/me/components/Canais/components/GoogleIcon";

interface IPortaisModal {
  show: boolean;
  toggle: () => void;
}

interface Sistema {
  id: number;
  nome: string;
  tipo: string;
  hash: string;
  app_id?: string;
  scope: string;
}

interface Email {
  id: number;
  empresa_id?: number;
  user_id?: number;
  sistema_id: number;
  valor: string;
  created_at: Date;
  updated_at: Date;
  is_revoked: boolean;
  nome_sistema: string;
  hash_sistema: string;
  tipo_sistema: string;
}

export const PortaisModal: React.FC<IPortaisModal> = ({ show, toggle }) => {
  const [valor, setValor] = useState<string | number | undefined>(undefined);
  const [sistemas, setSistemas] = useState<Sistema[]>();
  const [selectedIntegration, setSelectedIntegration] = useState<Sistema>();
  const [equipes, setEquipes] = useState<any>([]);
  const [equipe, setEquipe] = useState(null);
  const [parameters, setParameters] = useState<{ sync_lead_fields: boolean }>({
    sync_lead_fields: false,
  });
  const [emails, setEmails] = useState<Email[]>();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [alert, setAlert] = useState<any>(null);

  const { empresaSelecionada } = useContext(EmpresaContext);

  useEffect(() => {
    loadEquipes();
  }, []);

  async function loadEquipes() {
    setEquipe(null);
    try {
      const response = await api.get(
        `common/empresas/${empresaSelecionada?.id}/equipes?captadora=A`,
      );
      const list = await response.data;
      //carrega apenas as equipes que não foram adicionadas a campanha
      setEquipes(list);
    } catch (error) {
      console.error(error);
    }
  }

  const getEmails = async () => {
    const response = await api.get(
      `esb/integracoes/ativas?types[]=service&empresaId=${empresaSelecionada?.id}`,
    );

    setEmails(response.data);
  };

  const getSistemas = async () => {
    const response = await api.get(
      `esb/integracoes/sistemas?types[]=text&types[]=oauth&types[]=portal&scope=E`,
    );

    setSistemas(response.data);
  };

  function handleClose() {
    setValor("");
    setSelectedIntegration(undefined);
    setParameters({ sync_lead_fields: false });
    toggle();
  }

  useEffect(() => {
    setParameters({ sync_lead_fields: false });
    setValor("");
  }, [selectedIntegration]);

  const handleAdCreate = async (hash: string) => {
    try {
      await api.post(`esb/integracoes/create-ad/${hash}`, {
        equipes: [+equipe!],
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleIntegrateNoOauth = async (hash: string) => {
    try {
      setIsLoading(true);

      await handleAdCreate(hash);

      const response = await api.post(`esb/integracoes/auth/text/${hash}`, {
        value: valor,
        empresaId: empresaSelecionada?.id,
        parameters:
          selectedIntegration?.hash === "salesforce-company-url"
            ? parameters
            : null,
      });

      handleClose();
      setIsLoading(false);

      setAlert(
        <ReactBSAlert
          success
          style={{ display: "block" }}
          title="Sucesso!"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
          btnSize=""
        >
          {response.data.message}
        </ReactBSAlert>,
      );
    } catch (err) {
      handleClose();
      setIsLoading(false);

      setAlert(
        <ReactBSAlert
          error
          style={{ display: "block" }}
          title="Falha!"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
          btnSize=""
        >
          Não foi possível realizar integração!
        </ReactBSAlert>,
      );

      console.log(err);
    }
  };

  useEffect(() => {
    getSistemas();
    getEmails();
  }, []);

  const customStyles = {
    control: (base: any) => ({
      ...base,
      height: "calc(2.75rem + 2px)",
    }),
  };

  return (
    <>
      {alert}
      <Modal isOpen={show} toggle={handleClose}>
        <ModalHeader>Nova Integração</ModalHeader>
        <ModalBody style={{ padding: "0 1.5rem" }}>
          <FormGroup>
            <Label for="integration">Integração</Label>
            <Select
              id="integration"
              className="basic-single"
              classNamePrefix="select"
              isSearchable
              styles={customStyles}
              placeholder="Selecione um portal"
              options={sistemas?.map((sistema: any) => ({
                value: sistema.id,
                label: sistema.nome,
              }))}
              onChange={(e: any) => {
                setSelectedIntegration(
                  sistemas?.find((item) => item.id === e.value),
                );
              }}
            />

            {selectedIntegration?.hash !== "baileys" && (
              <span>
                <InputGroup className="mt-3">
                  <label htmlFor="equipes">Equipes:</label>
                  <Select2
                    id="equipes"
                    maximumInputLength={100}
                    className="form-control"
                    onSelect={(e) => setEquipe(e.target.value)}
                    data={equipes.map((item: any) => ({
                      text: item.nome,
                      id: item.id,
                    }))}
                    value={equipe}
                  />
                </InputGroup>
              </span>
            )}

            {selectedIntegration?.tipo === "portal" && (
              <span>
                <InputGroup className="mt-3">
                  <label htmlFor="email">Email:</label>
                  <Select2
                    id="email"
                    maximumInputLength={100}
                    className="form-control"
                    onSelect={(e) => setValor(e.target.value)}
                    data={emails?.map((item: Email) => ({
                      text: item.valor,
                      id: item.id,
                    }))}
                    value={valor}
                  />
                </InputGroup>
              </span>
            )}

            {selectedIntegration?.tipo === "text" && (
              <span>
                <InputGroup
                  className="mt-3"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  {selectedIntegration?.hash === "pitom" && (
                    <label htmlFor="valor">Token:</label>
                  )}
                  {selectedIntegration?.hash === "eemovel-agro" && (
                    <label htmlFor="valor">Token:</label>
                  )}
                  {selectedIntegration?.hash === "salesforce-company-url" && (
                    <label htmlFor="valor">URL:</label>
                  )}
                  {selectedIntegration?.hash === "baileys" && (
                    <label htmlFor="valor">Rota:</label>
                  )}
                  {selectedIntegration?.hash === "usados-br" && (
                    <label htmlFor="valor">
                      Login: (usuário e senha separados por "/")
                    </label>
                  )}
                  <Input
                    id="valor"
                    type="text"
                    className="form-control"
                    style={{ width: "100%", borderRadius: "0.25rem" }}
                    value={valor}
                    onChange={(e: SyntheticEvent) => {
                      setValor((e.target as HTMLInputElement).value);
                    }}
                  />
                </InputGroup>
              </span>
            )}

            {selectedIntegration?.hash === "salesforce-company-url" && (
              <span>
                <InputGroup
                  className="mt-3"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <label htmlFor="valor">Parametros:</label>
                  <div className="custom-control custom-checkbox">
                    <input
                      id="check-sync-lead"
                      className="custom-control-input"
                      type="checkbox"
                      checked={parameters.sync_lead_fields}
                      onChange={() => {
                        setParameters({
                          sync_lead_fields: !parameters.sync_lead_fields,
                        });
                      }}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="check-sync-lead"
                    >
                      Sincronizar dados de Leads
                    </label>
                  </div>
                </InputGroup>
              </span>
            )}
          </FormGroup>
        </ModalBody>

        <ModalFooter style={{ paddingTop: ".25rem" }}>
          <Button color="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          {/* Show enabled button cases */}
          {(selectedIntegration?.tipo === "text" ||
            selectedIntegration?.tipo === "portal") &&
            equipe &&
            valor && (
              <Button
                color="primary"
                onClick={() => {
                  handleIntegrateNoOauth(selectedIntegration.hash);
                }}
              >
                Integrar
                <Spinner
                  style={{ marginLeft: "4px" }}
                  hidden={!isLoading}
                  className="mr-2"
                  color="light"
                  size="sm"
                />
              </Button>
            )}

          {selectedIntegration?.hash === "mercado-livre" && equipe && (
            <Button
              color="primary"
              onClick={async () => {
                await handleAdCreate(selectedIntegration.hash);

                window.location.href = `https://auth.mercadolivre.com.br/authorization?response_type=code&client_id=${selectedIntegration.app_id}&redirect_uri=https://app.playnee.com/admin/callback/mercado-livre`;
              }}
            >
              Integrar
              <Spinner
                style={{ marginLeft: "4px" }}
                hidden={!isLoading}
                className="mr-2"
                color="light"
                size="sm"
              />
            </Button>
          )}

          {/* Show disabled button cases */}
          {(selectedIntegration?.tipo === "text" ||
            selectedIntegration?.tipo === "portal") &&
            equipe &&
            !valor && (
              <Button disabled color="primary">
                Integrar
              </Button>
            )}
          {!selectedIntegration ||
            (!equipe && (
              <Button disabled color="primary" onClick={() => {}}>
                Integrar
              </Button>
            ))}
        </ModalFooter>
      </Modal>
    </>
  );
};
